<mat-card>
    <mat-card-header style="margin-bottom: 20px">
        <mat-card-title>Oportunidades</mat-card-title>
        <button
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="Nova Oportunidade"
            (click)="openCadastro()">
            <mat-icon>add_circle</mat-icon>
        </button>

        <button
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="Consultar"
            (click)="openFiltro()">
            <mat-icon>search</mat-icon>
        </button>

        <button
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="Exportar Oportunidade"
            (click)="exportar()">
            <mat-icon>cloud_download</mat-icon>
        </button>

    </mat-card-header>
    <mat-card-content>
        <ngx-datatable 
                #table 
                class='material' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'>
                

                <ngx-datatable-column name="Data" prop="data_oportunidade" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-data_oportunidade="value" ngx-datatable-cell-template>
                        {{data_oportunidade | date:'dd/MM/yyyy'}}
                    </ng-template>
                </ngx-datatable-column>                  
                
                <ngx-datatable-column name="Assessor" prop="assessor" [sortable]="true" *ngIf='usuario.role_id != 5'>
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span> {{row.cliente.assessor?.name}}</span><br/>
                        <span> {{row.cliente.escritorio?.nome_fantasia}} </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="false"  *ngIf="cliente_id == null">
                    <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                        <span> {{ cliente.numero_xp }}</span><br/>
                        <span> {{ cliente.nome }} </span>
                    </ng-template>
                </ngx-datatable-column>
                

                <ngx-datatable-column name="Produto/Serviço" prop="tipo_oportunidade" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-tipo_oportunidade="value" ngx-datatable-cell-template>
                        {{tipo_oportunidade.nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Decrição" prop="descricao" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-descricao="value" ngx-datatable-cell-template>
                        {{descricao}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Valor" prop="valor" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-valor="value" ngx-datatable-cell-template>
                        R$ {{ valor | number : '1.2-2'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Data de Retorno" prop="data_retorno" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-data_retorno="value" ngx-datatable-cell-template>
                        {{data_retorno | date:'dd/MM/yyyy'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Cliente Contactado" prop="cliente_aceitou" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <button 
                            mat-button
                            matTooltip="Sem Resposta" 
                            [disabled]="!isResponse(row)"
                            *ngIf="!isResponse(row)"
                        >
                            <mat-icon  class="nao-confirmado">close</mat-icon>
                        </button>
                        <button 
                            mat-button
                            matTooltip="Ver Resposta" 
                            *ngIf="isResponse(row)"
                            (click)="openResposta(row)"
                        >
                            <mat-icon class="confirmado">check</mat-icon>
                        </button>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button mat-icon-button matTooltip="Alterar Ação" (click)="openAlterar(id)">
                            <mat-icon aria-label="Editar Ação">edit</mat-icon>
                        </button>

                        <button mat-icon-button color="warn" matTooltip="Excluir Ação" (click)="delete(id)">
                            <mat-icon aria-label="Excluir Ação">delete</mat-icon>
                        </button>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
    </mat-card-content>
</mat-card>